// Photo uploader main component
// All of the main states and functions related to photo uploader is stored here.

// Upload precedure :
// 1) Get the value of the input element in DOM after its value changes (a file is uploaded)
// 2) Send the file name to API and get an upload URL to min.io service
// 3) Pass the upload URL to the function that will upload the file to min.io
// 4) Wait for the upload to complete (reoccuring function)
// 5) Update the state

import React, { useEffect, useRef, useState } from "react";
import ContentHeader from "../../ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../../Assets/Images/sm-Circle.svg";
import UploadWidgetPhoto from "./Components/UploadWidgetPhoto";
import UploadZone from "./Components/UploadZone";
import "../../../../../Assets/Styles/UploadZone.scss";
import { Config } from "../../../../../Config";
import axios from "axios";
import { formatDate } from "../../../../../Helper_functions";

const PhotoUploader = (props) => {
  const TimerRef = useRef(null);
  const [Files, setFiles] = useState([]);
  const [BinaryFiles, setBinaryFiles] = useState([]);
  const [SizeLimits, setSizeLimits] = useState({
    zipFile: 0,
    photoFile: 0,
  });

  useEffect(() => {
    fetchSizeLimits();
    fetchHistory();
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const fetchHistory = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/bulk-profile-picture",
      headers: {
        Authorization: "Berare " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        createHistoryData(Res.data);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const switchStatus = (Status) => {
    if (Status === "COMPLETED") {
      return "success";
    } else if (Status === "PROCESSING") {
      return "loading";
    } else if (Status === "FAILED") {
      return "failed";
    }
  };

  const createHistoryData = (Items) => {
    let HistoryItems = [];
    Items.map((Item) => {
      HistoryItems.push({
        name: Item.fileName,
        lastModified: new Date(Item.createdTime).getTime(),
        size: "",
        type: "",
        path: Item.thumbnailUrl,
        status: switchStatus(Item.status),
        percentage: 100,
        ErrorMessage: Item.message,
      });
    });
    setFiles(HistoryItems);
  };

  const fetchSizeLimits = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/application-setting/upload-limit",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setSizeLimits({
          photoFile: Res.data.photoSizeLimitKb,
          zipFile: Res.data.zipSizeLimitMb,
        });
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const bytesToMegaBytes = (bytes) => bytes / 1024 ** 2;

  const saveFile = (FileItem) => {
    setBinaryFiles([...BinaryFiles, FileItem]);
    let NewFile = {
      name: FileItem.name,
      lastModified: FileItem.lastModified,
      size: FileItem.size,
      type: FileItem.type,
      path: createImagePreviewURL(FileItem), // the URL to display the uploaded image, it will be null for zip files
      status: "loading",
      percentage: 0,
    };

    let FileExtension = FileItem.name.slice(
      FileItem.name.indexOf("."),
      FileItem.name.length
    );
    if (
      FileExtension.toLowerCase() !== ".png" ||
      FileExtension.toLowerCase() !== ".jpg" ||
      FileExtension.toLowerCase() !== ".jpeg"
    ) {
      NewFile.path = null;
    }
    let PrevItems;
    if (Files.length >= 5) {
      PrevItems = [...Files]
        .reverse()
        .splice([...Files].length - 4, [...Files].length);
    } else {
      PrevItems = [...Files].reverse();
    }
    let NewFilesArray = [...PrevItems, NewFile];
    setFiles(NewFilesArray.reverse());

    // validation of file size limit based on the extention (".zip" or an image file)
    if (FileExtension.toLowerCase() === ".zip") {
      if (
        parseInt(bytesToMegaBytes(NewFile.size)) > parseInt(SizeLimits.zipFile)
      ) {
        let Items = [...NewFilesArray];
        Items[0].status = "failed";
        Items[0].ErrorMessage = translateText(
          "photo_uploader_validation_error_file_size"
        );
        setFiles(Items);
        createHistoryItem(
          FileItem.name,
          translateText("photo_uploader_validation_error_file_size")
        );
      } else {
        startUpload(NewFile, NewFilesArray, [...BinaryFiles, FileItem]);
      }
    } else if (
      parseInt(NewFile.size * 0.001) > parseInt(SizeLimits.photoFile)
    ) {
      let Items = [...NewFilesArray];
      Items[0].status = "failed";
      Items[0].ErrorMessage = translateText(
        "photo_uploader_validation_error_file_size_single"
      );
      setFiles(Items);
      createHistoryItem(
        FileItem.name,
        translateText("photo_uploader_validation_error_file_size_single")
      );
    } else {
      // file size validation passed:
      startUpload(NewFile, NewFilesArray, [...BinaryFiles, FileItem]);
    }
  };

  const createHistoryItem = (FileName, ErrorType) => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/bulk-profile-picture/validation-message",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        fileName: FileName,
        message: ErrorType,
        status: "FAILED",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const startUpload = (FileItem, NewFilesArray, BinaryFilesArray) => {
    // waiting for the upload bar to be through and giving the user time to decide if they want to
    // cancel the upload.
    setTimeout(() => {
      if (document.getElementById("upload-widget-" + 0 + "-modal") === null) {
        sendFileToAPI(FileItem, 0, NewFilesArray, BinaryFilesArray);
      } else {
        TimerRef.current = setInterval(() => {
          if (
            TimerRef.current &&
            document.getElementById("upload-widget-" + 0 + "-modal") === null
          ) {
            clearInterval(TimerRef.current);
            if (!document.getElementById("upload-widget-" + 0 + "-cancelled")) {
              sendFileToAPI(FileItem, 0, NewFilesArray, BinaryFilesArray);
            } else {
              // in this case the user has accepted to cancell the upload
              return null;
            }
          }
        }, 1000);
      }
    }, 2500);
  };

  const sendFileToAPI = (FileItem, FileIndex, FilesList, BinaryFilesArray) => {
    onFileUpload(FileItem, FileIndex, FilesList, BinaryFilesArray);
  };

  //Get signed MinIO upload URL from BE
  const onFileUpload = (FileItem, FileIndex, FilesList, BinaryFilesArray) => {
    axios
      .get(
        window._env_.API_URL +
          Config.AuthBaseURL +
          "/api/profile/bulk-profile-picture/upload-url",
        {
          params: {
            filename: FileItem.name,
          },
        }
      )
      .then((resp) => {
        console.log(resp);
        const config = {
          onUploadProgress: (progressEvent) => {
            var PercentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            let Items = [...FilesList];
            Items[FileIndex].percentage = PercentCompleted;
          },
        };

        // Upload binary file to minio
        axios
          .put(resp.data, [...BinaryFilesArray].pop(), config)
          .then((response) => {
            console.log(response);
            //Tell BE file upload is completed and proceed to applying profile pictures
            const formDataBE = new FormData();
            formDataBE.append("fileName", FileItem.name);
            axios
              .post(
                window._env_.API_URL +
                  Config.AuthBaseURL +
                  "/api/profile/bulk-profile-picture",
                formDataBE
              )
              .then((response) => {
                console.log(response);
                checkProgress(response.data.id, FileIndex, FilesList);
              });
          })
          .catch((Err) => {
            console.log(Err);
          });
      })
      .catch((Err) => {
        console.log(Err.response);
        checkProgress(null, FileIndex, FilesList, Err.response.data.key);
      });
  };

  // uploadId is only null when a wrong file type is uploaded
  // ErrorKey is only passed down if there was an error during the upload progress
  const checkProgress = (uploadId, FileIndex, FilesList, ErrorKey) => {
    if (uploadId) {
      axios
        .get(
          window._env_.API_URL +
            Config.AuthBaseURL +
            "/api/profile/bulk-profile-picture/" +
            uploadId
        )
        .then((response) => {
          if (response.data.status === "PROCESSING") {
            setTimeout(() => {
              let Items = [...FilesList];
              Items[FileIndex].status = "loading";
              Items[FileIndex].processedCount =
                response.data.processedFileCount;
              Items[FileIndex].totalCount = response.data.fileCount;

              checkProgress(response.data.id, FileIndex, FilesList);
            }, 500);
          }
          console.log(response);
          if (response.data.status === "COMPLETED") {
            let Items = [...FilesList];
            Items[FileIndex].status = "success";
          } else if (response.data.status === "FAILED") {
            let Items = [...FilesList];
            Items[FileIndex].status = "failed";
            Items[FileIndex].ErrorMessage = response.data.message;
          }
        })
        .catch((Err) => {
          console.log(Err);
          if (Err.response && Err.response.data.status === "FAILED") {
            let Items = [...FilesList];
            Items[FileIndex].status = "failed";
            Items[FileIndex].ErrorMessage = Err.response.message;
            setFiles(Items);
          }
        });
    } else {
      // only true when an error has occured due to wrong file format
      if (ErrorKey === "mismatch_error") {
        let Items = [...FilesList];
        Items[FileIndex].status = "failed";
        Items[FileIndex].ErrorMessage = translateText(
          "photo_uploader_validation_error_fiormat"
        );
      }
    }
  };

  const createImagePreviewURL = (Img) => {
    return URL.createObjectURL(Img);
  };

  const cancelItem = (Index) => {
    let Items = [...Files];
    Items[Index].status = "cancelled";
    setFiles(Items);
  };

  return (
    <div className="main-content security-settings ai">
      <ContentHeader PageName={translateText("photo_uploader")} />
      <div className="content-header">
        <div className="address">
          <p>AI</p>
          <img src={Circle} alt="." />
          <p>{translateText("photo_uploader")}</p>
        </div>
      </div>
      <div className="simple-form">
        <section className="form-head">
          <h1>{translateText("photo_uploader")}</h1>
        </section>
        <main className="form-body">
          <UploadZone
            LangData={props.LangData}
            SaveFile={(FileItem) => saveFile(FileItem)}
          />
          {Files.length > 0 ? (
            <div className="uploaded-files">
              <p className="files-wrapper-title">
                {translateText("display_the_last_5_files")}
              </p>
              {[...Files].map((Item, i) => (
                <UploadWidgetPhoto
                  ImageSrc={Item.path}
                  Id={"upload-widget-" + i}
                  ProcessedCount={Item.processedCount}
                  TotalCount={Item.totalCount}
                  Name={Item.name}
                  Percentage={Item.percentage ? Item.percentage : 0}
                  Status={Item.status}
                  LangData={props.LangData}
                  ErrorMessage={Item.ErrorMessage}
                  SizeLimits={SizeLimits}
                  UploadDate={
                    Item.lastModified ? formatDate(Item.lastModified) : ""
                  }
                  CancelUpload={() => cancelItem(i)}
                />
              ))}
            </div>
          ) : null}
        </main>
        <section className="footer-hint">
          <i className="feather-info"></i>
          <p>
            {translateText("photo_uploader_info_pt1")} {SizeLimits.zipFile} MB{" "}
            {translateText("photo_uploader_info_pt2")} PNG/JPEG{" "}
            {translateText("photo_uploader_info_pt3")} {SizeLimits.photoFile}{" "}
            KB.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PhotoUploader;
